import { ResponseGetViolationMerchflow_merchflowId_ } from "@CommonApi/violation/merchflow/_merchflowId_";
import { omniAtom } from "src/utils/atoms";
import type { CdtSelection, MerchflowReviewUpdateStep } from "./types";

export interface MerchflowReviewUpdateModalData {
  merchflowId: number;
  violations?: ResponseGetViolationMerchflow_merchflowId_;
  /** Where the wizard opens; "Next → Update" from a CDT version lands on the rules step. */
  initialStep?: MerchflowReviewUpdateStep;
  /** The CDT choice the wizard starts with (the rules step shows it preselected). */
  initialCdtSelection?: CdtSelection;
}

export const merchflowReviewUpdateAtom = omniAtom({
  value: null as null | MerchflowReviewUpdateModalData,
  key: "modals/merchflowReviewUpdate",
});
